// extracted by mini-css-extract-plugin
export var sliderRange = "_o3-2";
export var sliderRoot = "_o3-0";
export var sliderThumb = "_o3-3";
export var sliderTrack = "_o3-1";